import axios from "axios"

export const getTip = async () => {

    const { data } = await axios.get(`${process.env.REACT_APP_AWS_URL}/api/surveytips`)

    return data;
}